// Общие типы приложения

export interface User {
  id: number
  name: string
  email: string
}

export interface ApiResponse<T> {
  data: T
  message?: string
  error?: string
}

// spec/admin-ui/navigation.md: admin-ui-navigation-R18, R25, R56, R57.
// spec/server/storage/auth.md: schema-auth-R31. Codes are supplied by auth.
export type PrivilegeId = string
export const PRIVILEGES = {
  RESOURCES: 'onebridge.resources.view',
  EVENTS: 'onebridge.event_listeners.view',
  EVENTS_EDIT: 'onebridge.event_listeners.edit',
  SCHEDULES: 'onebridge.schedules.view',
  SCHEDULES_EDIT: 'onebridge.schedules.edit',
  PROJECTS: 'onebridge.projects.view',
  PROJECTS_EDIT: 'onebridge.projects.edit',
  HISTORY: 'onebridge.execution_history.view',
  HISTORY_LOGS: 'onebridge.execution_history.logs',
  HISTORY_EDGE_DATA: 'onebridge.execution_history.edge_data',
  HISTORY_RUN: 'onebridge.execution_history.run',
  DATA_SERVICES: 'onebridge.data_services.view',
  DATA_SERVICES_EDIT: 'onebridge.data_services.edit',
} as const

/**
 * Информация о версии приложения
 */
export interface VersionInfo {
  readonly version: string
  readonly commit?: string
  readonly buildDate?: string
}

/**
 * Дефолтная версия (пока нет бэкенда)
 */
export const DEFAULT_VERSION: VersionInfo = {
  version: '2.0.0-alpha',
  commit: undefined,
  buildDate: undefined,
}

export type * from './auth'
export * from './data-services'
export * from './execution-history'
export * from './listeners'
export * from './projects'
export * from './resources'
export * from './schedules'
